export default {
  translations: {
    templateHeaderAssetThreshold: 'Asset Threshold',
    templateHeaderValue: 'Value',
    name: 'Template Name',
    doorLeftOpen: 'Door Left Open',
    warningLowTemperature: 'Warning Low Temperature',
    criticalHighTemperature: 'Critical High Temperature',
    doorNeglectOpen: 'Door Neglect Open',
    idleAsset: 'Idle Asset',
    warningHighTemperature: 'Warning High Temperature',
    criticalLowTemperature: 'Critical Low Temperature',
    warningHighHumidity: 'Warning High Humidity',
    criticalHighHumidity: 'Critical High Humidity',
    lowLight: 'Low Light',
    abnormalPower: 'Abnormal Power',
    compressorTemperature: 'Compressor Temperature',
    compressorVibration: 'Compressor Vibration',
    unauthorizedMovement: 'Unauthorized Movement',
    outOfLocation: 'Out Of Location',
    fridgeInteriorHumidityTemperatureLightLevel:
      'Fridge Interior Humidity/Temperature/Light level',
    roomTemperature: 'Room Temperature',
    doorOpenCount: 'Door Open Count',
    compressorInteriorTemperatureVibrationsACCurrent:
      'Compressor Interior Temperature/Vibrations/AC Current',
    placeholderName: 'Name',
    placeholderPerMinutes: 'Per Minutes',
    placeholderPerC: 'Per °C',
    'placeholderPer%': 'Per %',
    placeholderPowerConsumption: 'Power Consumption',
    placeholderCompressorTemperature: 'Compressor Temperature',
    placeholderCompressorVibration: 'Compressor Vibration',
    placeholderRadiusPerMeters: 'Radius Per Meters',
    placeholderInteriorPerMinutes: 'Interval Per Minute',
    placeholderPerLUX: 'Per LUX',
    labelPleaseEnterValidNumber: 'Please Enter Valid Number',
    labelRequired: 'Required',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    delete: 'Delete',
    Activate: ' Activate ',
    Deactivate: ' Deactivate ',
    back: 'Back',
    deleteMsg: 'Are you sure you want to deactivate this device?!',
    assetName: 'Asset Name',
    deviceName: 'Device Name',
    'device name': 'Device Name',
    'device id': 'Device Id',
    'device status': 'Device Status',
    'asset name': 'Asset Name',
    'asset type': 'Asset Type',
    deviceId: 'Device ID',
    alertSettings: 'Alert Settings',
    dynamicAlertSettings: 'Dynamic Alert Settings',
    customerName: 'Customer Name',
    description: 'Description',
    registrationDate: 'Registration Date',
    batteryInstallationDate: 'Battery Installation Date',
    group: 'Group',
    geoLocation: 'GEO Location',
    country: 'Country',
    assetNameLabel: 'Asset Name',
    assetTypeLabel: 'Asset Type',
    regionLabel: 'Region',
    devicesLabel: 'Devices',
    city: 'City',
    address: 'Address',
    facilityID: 'Facility ID',
    warrantyExpirationDate: 'Warranty Expiration Date',
    sampling: 'Sampling',
    details: 'Details',
    Details: 'Details',
    deviceDetails: 'Device Details',
    thereIsNoDevicesToShow: 'There is no devices to show!',
    thereIsNoCustomersToShow: 'There is no customers to show!',
    status: 'Status',
    actions: 'Actions',
    configure: 'Configure',
    provision: 'Provision',
    assetsList: ' Assets list',
    devicesList: 'Devices List',
    customersList: 'Customers List',
    REGISTERED: 'REGISTERED',
    CONFIGURED: 'CONFIGURED',
    PROVISIONED: 'PROVISIONED',
    ACTIVE: 'ACTIVE',
    signOut: 'Sign Out',
    settings: 'Settings',
    yourProfile: 'Your Profile',
    signedInAs: 'Signed in as',
    spectro: 'Spectro',
    assetDetails: 'Asset Details',
    formHeader: 'Login',
    formEmailLabel: 'Email',
    CustomerSettings: 'Settings',
    customerHierarchy: 'Customer Hierarchy',
    Hierarchy: ' Hierarchy',
    emailInputPlaceholder: 'Enter email',
    customerSettings: 'Customer Settings',
    emailErrorMessage: 'Invalid E-mail',
    formPasswordLabel: 'Password',
    passwordInputPlaceholder: 'Enter password',
    passwordErrorMessage: 'Invalid Password',
    rememberMeLabel: 'Remember Me',
    forgetPassword: 'Forgot password?',
    loginSubmitButton: 'Submit',
    formErrorMessage: 'Invalid Email Or Password',
    formInactiveErrorMessage: 'User Account is Not Active',
    userManagement: 'User Management',
    companyManagement: 'Company Management',
    assetManagement: 'Asset Management',
    tankDeviceManagement: 'Device Management',
    alertsAndManagement: 'Alerts & Notifications Management',
    deviceProvision: 'Device Provision',
    addDeviceHeaderModal: 'Add New Device',
    addAssetHeaderModal: 'Add New Asset',
    addCustomerHeaderModal: 'Add New Customer',
    assetType: 'Asset Type',
    addDeviceNameLabel: 'Device Name',
    assetNamePlaceHolder: 'Enter Asset Name',
    required: 'Required',
    assetGroupLabel: 'Asset Group',
    selectGroupOption: 'Select group',
    facilityLabel: 'Facility',
    addressPlaceHolder: 'Enter address',
    geoLocationLabel: 'Geo Location',
    assetGeolocationPlaceholder: 'Enter Asset Geolocation',
    invalidGeolocationErrorMessage: 'Invalid Geolocation',
    countryLabel: 'Country',
    cityLabel: 'City',
    assetDomain: 'Asset Domain',
    enterCityPlaceholder: 'Enter city',
    addressLabel: 'Address',
    addressPlaceholder: 'Enter Address',
    descriptionLabel: 'Description',
    closeBtn: 'Close',
    addDeviceAlertDialogHeader: 'Error',
    addDeviceAction: 'Add Asset',
    addTankDeviceAction: 'Add Device',
    addColdDeviceAction: 'Add Device',
    bulkUploadAction: 'Bulk upload',
    assetsBulkUploadAction: 'Assets Bulk upload',
    bulkConfigAction: 'Bulk Config',
    addCustomerAction: 'Add Customer',
    customerDetails: 'Customer Details',
    provisioningConfirmDialogHeader: 'Device Provision',
    provisioningConfirmDialogMessage: 'Provision this Device?',
    provisioningConfirmDialogBtn: 'Yes',
    provisioningConfirmDialogNoBtn: 'No',
    provisioningConfirmDialogErrorHeader: 'Device Provisioning Issue',
    selectConfigurationTemplate: 'Select Configuration Template',
    chooseYourTemplate: 'Choose Your Template',
    selectTemplate: 'Select Template',
    submit: 'Submit',
    doorOpenNeglectLabel: 'Door Open Neglect Threshold',
    totalDevices: 'Total Devices:',
    totalAssets: 'Total Assets:',
    successDevices: 'Success Devices:',
    successAssets: 'Success Assets:',
    criticalHighTempAlarm: 'Critical High Temperature Alarm',
    criticalLowTempAlarm: 'Critical Low Temperature Alarm',
    warningHighTempAlarm: 'Warning High Temperature Alarm',
    warningLowTempAlarm: 'Warning Low Temperature Alarm',
    criticalHighHumidityAlarm: 'Critical High Humidity Alarm',
    warningHighHumidityAlarm: 'Warning High Humidity Alarm',
    warningLowLightAlarm: 'Warning Low Light Alarm',
    doorLeftOpenAlarm: 'Door Left Open Alarm',
    doorNeglectOpenAlarm: 'Door Neglect Open Alarm',
    deviceInactiveAlarm: 'Device Inactive Alarm',
    tempIncomplianceReport: 'Temperature Incompliance Report',
    humidityIncomplianceReport: 'Humidity Incompliance Report',
    lightIncomplianceReport: 'Light Incompliance Report',
    incompliantFacilitiesReport: 'Incompliant Facilities Report',
    unauthorizedMovementThreshold: 'Unauthorized Movement Threshold',
    TitleLabel: 'Customer Title',
    titlePlaceHolder: 'Enter Title',
    identityNumberLabel: 'Identity Number',
    identityNumberPlaceHolder: 'Identity Number',
    commercialRecordNumberLabel: 'Commercial Record Number',
    commercialRecordNumberPlaceHolder: 'Commercial Record Number',
    commercialRecordIssueDateHijriLabel: 'Commercial Record Issue Date Hijri',
    commercialRecordIssueDateHijriPlaceHolder:
      'Please follow format yyyy-mm-dd',
    phoneNumberLabel: 'Phone Number',
    extensionNumberLabel: 'Extension Number',
    extensionNumberPlaceHolder: 'Extension Number',
    emailAddressLabel: 'Email Address',
    emailAddressPlaceHolder: 'Email Address',
    managerNameCodeLabel: 'Manager Name',
    managerNamePlaceHolder: 'Manager Name',
    managerPhoneNumberLabel: 'Manager Phone Number',
    managerPhoneNumberPlaceHolder: 'Manager Phone Number',
    managerMobileNumberLabel: 'Manager Mobile Number',
    managerMobileNumberPlaceHolder: 'Manager Mobile Number',
    phoneLabel: 'Phone',
    activityLabel: 'Activity',
    activityPlaceHolder: 'Activity',
    sfdaCompanyActivityLabel: 'SFDA Company Activity',
    sfdaCompanyActivityPlaceHolder: 'SFDA Company Activity',
    dateOfBirthHijriLabel: 'Date Of Birth Hijri',
    dateOfBirthHijriPlaceHolder: 'Date Of Birth Hijri',
    firstNameLabel: 'First Name',
    firstNamePlaceHolder: 'First Name',
    descriptionPlaceHolder: 'Description',
    countryPlaceHolder: 'Country',
    cityPlaceHolder: 'City',
    statePlaceHolder: 'State',
    zipCodeLabel: 'Zip Code',
    zipCodePlaceHolder: 'Zip Code',
    address2Label: 'Address 2',
    address2PlaceHolder: 'Enter 2nd Address',
    phonePlaceHolder: 'Phone',
    emailLabel: 'Email',
    lastNameLabel: 'Last Name',
    lastNamePlaceHolder: 'Enter Last Name',
    emailPlaceHolder: 'Enter Email',
    customer: 'Customer',
    sfdaDateOfbirthgregorianLabel: 'Date Of Birth Gregorian',
    sfdaDateOfbirthgregorianPlaceHolder: 'Enter Date In Gregorian Format',
    ManagerNamePlaceHolder: 'Enter Manager Name',
    'no of customer facilities': 'No. Of Customer Facilities',
    'no of customer assets': 'No. Of Customer Assets',
    'no of customer active devices': 'No. Of Customer Active Devices',
    'sfda commercial record number': 'SFDA Commercial Record Number',
    'sfda commercial record issue date hijri':
      'SFDA Commercial Record Issue Date Hijri',
    'sfda manager name': 'Manager Name',
    'sfda manager phone number': 'Manager Phone Number',
    'sfda manager mobile number': 'Manager Mobile Number',
    'sfda identity number': 'Identity Number',
    'sfda phone number': 'Phone Number',
    'sfda extension number': 'Extension Number',
    'sfda email address': 'Email Address	',
    'sfda company activity': 'Company Activity',
    facilityManagement: 'Hierarchy Management',
    addFacilityAction: 'Add Facility',
    facilitiesList: ' Facilities List',
    addFacilityHeaderModal: 'Add Facility',
    facilityType: 'Facility Type',
    nameLabel: 'Facility Name',
    NamePlaceHolder: 'Enter Facility Name',
    City: 'City',
    Address: 'Address',
    'Enter address': 'Enter Facility Address',
    latitudeLabel: 'Facility Latitude',
    latitudePlaceHolder: 'Enter Latitude',
    longitudeLabel: 'Facility Longitude',
    longitudePlaceHolder: 'Enter Facility Longitude',
    landCoordinatesLabel: 'Land Coordinates :-',
    landCoordinatesPlaceHolder: 'Enter Land Coordinates',
    licenseNumberLabel: 'License Number',
    licenseNumberPlaceHolder: 'Enter License Number',
    licenseIssueDateLabel: 'License Issue Date',
    licenseIssueDatePlaceHolder: 'Enter License Issue Date',
    licenseExpiryDateLabel: 'License Expiry Date',
    licenseExpiryDatePlaceHolder: 'Enter License Expiry Date',
    PhonePlaceHolder: 'Enter Phone',
    managerMobileLabel: 'Manager Mobile',
    managerMobilePlaceHolder: 'Enter Manager Mobile',
    Email: 'Email',
    'Enter Email': 'Enter Email',
    landAreaInSquareMeterLabel: 'Land Area In m²',
    landAreaInSquareMeterPlaceHolder: 'Enter Land Area In m²',
    StorageType: 'Storage Type',
    'Room TemperatureLabel': 'Room Temperature',
    'Room TemperaturePlaceHolder': 'Enter Room Temperature',
    FrozenLabel: 'Frozen',
    FrozenPlaceHolder: 'Enter Frozen Value',
    ChilledLabel: 'Chilled',
    ChilledPlaceHolder: 'Enter Chilled Value',
    'Cold StorageLabel': 'Cold Storage',
    'Cold StoragePlaceHolder': 'Cold Storage Value',
    'No Heat ExposureLabel': 'No Heat Exposure',
    'No Heat ExposurePlaceHolder': 'Enter No Heat Exposure',
    ChilledVegetablesAndFruitsLabel: 'Chilled Vegetables And Fruits',
    ChilledVegetablesAndFruitsPlaceHolder: 'Enter Chilled Value',
    RoomTemperaturePlaceHolder: 'Enter Room Temperature value',
    DryLabel: 'Dry Value',
    DryPlaceHolder: 'Enter Dry Value',
    FodderLabel: 'Fodder Value',
    FodderPlaceHolder: 'Enter Fodder Value',
    PesticidesLabel: 'Pesticides',
    PesticidesPlaceHolder: 'Pesticides Value',
    frozenDrugsTemperatureLabel: 'Frozen Temperature',
    frozenDrugsTemperaturePlaceHolder: 'Frozen Temperature No',
    FrozenDrugsHumdityLabel: 'Frozen Humidity',
    FrozenDrugsHumdityPlaceHolder: 'Frozen Humidity No',
    ChilledDrugsTempLabel: 'Chilled Temperature',
    ChilledDrugsTempPlaceHolder: 'Chilled Temperature',
    ChilledFoodDrugsLabel: 'Chilled Humidity',
    ChilledDrugsHumPlaceHolder: 'Chilled Humidity',
    DrugsRoomTemperatureTempLabel: 'Room Temperature',
    DrugsRoomTemperatureHumLabel: 'Room Humidity',
    DrugsRoomTemperatureHumPlaceHolder: 'Room Humidity',
    DrugsRoomTemperatureTempPlaceHolder: 'Room Temperature',
    CosmeticsRoomTemperatureTempLabel: 'Room Temperature',
    CosmeticsRoomTemperatureTempPlaceHolder: 'Room Temperature',
    CosmeticsRoomTemperatureHumLabel: 'Room Humidity',
    CosmeticsRoomTemperatureHumPlaceHolder: 'Room Humidity',
    frozenMedicalTemperatureLabel: 'Frozen Temperature',
    frozenMedicalHumdityLabel: 'Frozen Humidity',
    ChilledMedicalTempLabel: 'Chilled Temperature',
    ChilledMedicalDrugsLabel: 'Chilled Humidity',
    MedicalRoomTemperatureTempLabel: 'Room Temperature',
    MedicalRoomTemperatureHumLabel: 'Room Humidity',
    MedicalColdStorageTempLabel: 'Cold Storage Temperature',
    MedicalColdStorageHumLabel: 'Cold Storage Humidity',
    MedicalNoHeatExposureTempLabel: 'No Heat Exposure Temperature',
    MedicalNoHeatExposureHumLabel: 'No Heat Exposure Humidity',
    MedicalNoHeatExposureHumPlaceHolder: 'No Heat Exposure Humidity',
    MedicalNoHeatExposureTempPlaceHolder: 'No Heat Exposure Temperature',
    MedicalColdStorageTempPlaceHolder: 'Cold Storage Temperature',
    MedicalColdStorageHumdPlaceHolder: 'Cold Storage Humidity',
    MedicalRoomTemperatureHumPlaceHolder: 'Room Humidity',
    MedicalRoomTemperatureTempPlaceHolder: 'Room Temperature',
    ChilledMedicalHumPlaceHolder: 'Chilled Humidity',
    ChilledMedicalTempPlaceHolder: 'Chilled Temperature',
    frozenMedicalTemperature: 'Frozen Temperature',
    frozenMedicalHumdity: 'Frozen Humdity',
    frozenFoodTemperatureLabel: 'Frozen Temperature',
    frozenFoodTemperaturePlaceHolder: 'Frozen Temperature',
    FrozenFoodHumdityLabel: 'Frozen Humdity',
    FrozenFoodHumdityPlaceHolder: 'Frozen Humdity',
    ChilledFoodTempLabel: 'Chilled Temperature',
    ChilledFoodTempPlaceHolder: 'Chilled Temperature',
    ChilledFoodHumPlaceHolder: 'Chilled Humidity',
    ChilledFoodHumLabel: 'Chilled  Humidity',
    ChilledVegetablesAndFruitsFoodTempLabel:
      'Chilled Vegetables & Fruits Temperature',
    ChilledVegetablesAndFruitsFoodTempPlaceHolder:
      'Chilled Vegetables & Fruits Temp',
    ChilledVegetablesAndFruitsFoodHumLabel:
      'Chilled Vegetables & Fruits Humidity',
    ChilledVegetablesAndFruitsFoodHumPlaceHolder:
      'Chilled Vegetables & Fruits  Humidity',
    DryFoodTempLabel: 'Dry Temperature',
    DryFoodTempPlaceHolder: 'Dry Temperature',
    DryFoodHumLabel: 'Dry Humidity ',
    DryFoodHumPlaceHolder: 'Dry Humidity',
    FodderTemperatureLabel: 'Fodder Temperature',
    FodderHumdityLabel: 'Fodder Humdity',
    FodderHumdityPlaceHolder: 'Fodder Humdity',
    FodderTemperaturePlaceHolder: 'Fodder Temperature',
    PesticidesTempLabel: 'Pesticides Temperature',
    PesticidesHumLabel: 'Pesticides Humidity',
    PesticidesHumlaceHolder: 'Pesticides Humidity',
    PesticidesTempPlaceHolder: 'Pesticides Temperature',
    roomNoLabel: 'Room No',
    floorLabel: 'Floor',
    photoNoLabel: 'Photo URL',
    frozenMedicalTemperaturePlaceHolder: 'Frozen Temperature',
    frozenMedicalHumdityPlaceHolder: 'Frozen Humdity',
    deviceInactiveLabel: 'Asset Inactive',
    phoneNumberPlaceHolder: 'Phone Number',
    ActivityLabel: 'Activity',
    StorageCode: 'Storage Code',
    storingCategory: 'Storing Category',
    vehiclePlateRightLetter: 'Vehicle Plate Right Letter',
    sequenceNumber: 'Sequence Number',
    vehiclePlateNumber: 'Vehicle Plate Number',
    vehiclePlateMiddleLetter: 'Vehicle Plate Middle Letter',
    vehiclePlateLeftLetter: 'Vehicle Plate Left Letter',
    imeiNumber: 'IMEI Number',
    plateType: 'Plate Type',
    startOperationTime: 'Start Operation Time',
    endOperationTime: 'End Operation Time',
    assetWeekSchedule: 'Asset Week Schedule',
    zoneId: 'Zone Name',
    roomNoPlaceholder: 'Room Number',
    floorPlaceholder: 'Floor',
    photoPlaceholder: 'Photo URL',
    thereIsNoFacilitiesToShow: 'There Is No Facilities To Show',
    facilityName: 'Facility Name',
    Type: 'Type',
    stateLabel: 'State',
    deviceInactivePlaceholder: 'Device Inactive Per minutes',
    gatewaysLabel: 'Gateways',
    driverNameLabel: 'Driver Name',
    driverNamePlaceholder: 'Enter Driver Name',
    carModelLabel: 'Car Model',
    carModelPlaceholder: 'Enter Car Model',
    templateName: 'Template Name',
    labelPleaseEnterValidName: 'Please Enter Valid Template Name',
    templateNameplaceholder: 'Enter Template Name',
    deviceLabel: 'Label',
    deviceTypeLabel: 'Device Type',
    deviceManagement: 'Device Management',
    tbDeviceName: 'Device Name',
    tbDeviceId: 'Device ID',
    type: 'Type',
    floor: 'Floor',
    'room no': 'Room No.',
    location: 'Location',
    photo: 'Photo',
    'storage type': 'Storage Type',
    'storage category': 'Storage Category	',
    'storage code': 'Storage Code',
    model: 'Model',
    serial: 'Serial',
    'start operation time': 'Start Operation Time',
    'end operation time': 'End Operation Time',
    'week schedule': 'Week Schedule',
    zone: 'Zone',
    'sequence number': 'Sequence Number',
    'vehicle plate number': 'Vehicle Plate Number',
    'vehicle plate right letter': 'Vehicle Plate Right Letter',
    'vehicle plate middle letter': 'Vehicle Plate Middle Letter',
    'vehicle plate left letter': 'Vehicle Plate Left Letter',
    'plate type': 'Plate Type',
    'imei number': 'IMEI Number',
    'driver name': 'Driver Name',
    'car model': 'Car Model',
    vehicleAssetAttributes: 'Vehicle Asset Attributes',
    changeProduct: 'My Products',
    'reseller name': 'Reseller Name',
    deviceStartOperationLabel: 'Start Operation',
    deviceEndOperationLabel: 'End Operation',
    'door open neglect': 'Door Open Neglect',
    'warning high temperature': 'Warning High Temperature',
    'warning low temperature': 'Warning Low Temperature',
    'critical high temperature': 'Critical High Temperature',
    'critical low temperature': 'Critical Low Temperature',
    'warning humidity': 'Warning Humidity',
    'critical humidity': 'Critical Humidity',
    'low light': 'Low Light',
    'abnormal power': 'Abnormal Power',
    'compressor temperature': 'Compressor Temperature',
    'compressor vibration': 'Compressor Vibration',
    'Unauthorized movement': 'Unauthorized Movement',
    'out of location': 'Out Of Location',
    'device inactive threshold': 'Device Inactive Threshold',
    'door open count': 'Door Open Count',
    assignAssetToDevices: 'Assign Devices To Asset',
    photoLabel: 'Asset Photo',
    fleetNameLabel: 'Fleet Name',
    fleetNamePlaceholder: 'Enter Fleet Name',
    assetPhotoPlaceholder: 'Photo',
  },
}
